import { call, put, takeLatest } from 'redux-saga/effects';
import * as Actions from './actions';
import * as Apis from './apis';

export function* getUser() {
  try {
    const data = yield call(Apis.getUser);
    yield put(Actions.getUserSuccess(data.user));
  } catch (error) {
    yield put(Actions.getUserFailure(error));
  }
}

export function* watchGetUserRequests() {
  yield takeLatest(Actions.USER_ACTIONS.REQUEST, getUser);
}
